import './public-path';
import './polyfills/nodelistForEach';
import './polyfills/objectAssign';
import './polyfills/customEvent';
import './polyfills/modernizr-custom';

import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import '../sass/theme.scss';
//import '../../scss/theme.scss.liquid';

import { merge } from 'lodash-es';
import { focusHash, bindInPageLinks } from '@shopify/theme-a11y';
// import { cookiesEnabled } from '@shopify/theme-cart';

import { picoapp } from 'picoapp';
// import { picoapp } from '../../picoapp';
import AppComponents from './AppComponents';
import AppViews from './AppViews';
import AppState from './AppState';

// import '../features/common';
import common from './features/common';
import icons from './features/icons';

import './features/webfonts';

const components = merge(AppComponents, AppViews);
const app = picoapp(components, AppState);
app.mount(['data-component', 'data-view']);

document.addEventListener('page.lazyloaded', () => {
  app.mount(['data-component', 'data-view']);
})

common.init(app);
icons.init();

// import { initComponents } from '../components/AsyncComponents';
// initComponents();

// Common a11y fixes
focusHash();
bindInPageLinks();

// Apply a specific class to the html element for browser support of cookies.
if (cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
}

function cookiesEnabled() {
  var cookieEnabled = navigator.cookieEnabled;
  if (!cookieEnabled) {
    document.cookie = 'testcookie';
    cookieEnabled = document.cookie.indexOf('testcookie') != -1;
  }
  return cookieEnabled;
}

// Generate the SVG Sprites
const files = require.context('!svg-sprite-loader!../icons/svg/', false, /.*\.svg$/);
files.keys().forEach(files);
